(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name renewals.controller:AssignExpiryTrainingCtrl
     *
     * @description
     *
     */
    angular
        .module('renewals')
        .controller('AssignExpiryTrainingCtrl', AssignExpiryTrainingCtrl);
    
    function AssignExpiryTrainingCtrl($uibModalInstance, modalParams, RenewalsService, MessageService, 
    		EventManagerService) {
        var vm = this;
        vm.model = {
            trainingSchedule: RenewalsService.adaptTrainingSchedules(modalParams.trainingSchedules),
            selectedExpiry: modalParams.selectedExpiray,
            selectedCrew: modalParams.selectedExpiray.crew,
            trainingAssignList: [],
            trainerTypes:[]
        };

        EventManagerService.registerEventListener(EventManagerService.EVENT.RENEWALS.ASSIGN_TRAINING, loadAvailableTraining);

        vm.onCloseClick = function () {
            $uibModalInstance.close();
        };
        
        vm.assignTraining = function (training, assignFlag) {
            RenewalsService.assignTraining(training, vm.model.selectedCrew, assignFlag);
        };

        function loadAvailableTraining() {
            vm.model.trainingSchedule = [];
            var params = RenewalsService.getScheduleTrainingByExpiry(vm.model.selectedExpiry);
            RenewalsService.getAvailableTrainings(params,
                function (response) {
                    if(response.success && response.hasOwnProperty('scheduleTrainingSlots')){
                        if(response.scheduleTrainingSlots.length>0){
                            vm.model.trainingSchedule = RenewalsService.adaptTrainingSchedules(response.scheduleTrainingSlots);
                        }else{
                            MessageService.warning('No Schedule trainings');
                        }
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }


        (function () {
            vm.model.trainingAssignList = RenewalsService.getTrainerTraineeList();
            RenewalsService.getTrainerTypes(function (trainerTypes) {
                vm.model.trainerTypes = trainerTypes;
            },function () {});
        })();
    }
}());